import { render, staticRenderFns } from "./operateButton.vue?vue&type=template&id=5e06feb6&"
import script from "./operateButton.vue?vue&type=script&lang=js&"
export * from "./operateButton.vue?vue&type=script&lang=js&"
import style0 from "./operateButton.vue?vue&type=style&index=0&id=5e06feb6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports